module.exports = "/assets/pfr.png?i31YM0r";